import React from "react";

function Popup({ visible, text, onClose, previewMode }) {
  if (!visible) return null;

  return (
    <div
      className={`${
        previewMode
          ? "relative"
          : "fixed left-0 top-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50"
      } z-50`}
    >
      <div className={`bg-white rounded-lg shadow-lg max-w-md w-full mx-auto ${previewMode ? "" : "z-60"}`}>
        {/* Popup Content */}
        <div className="p-6 flex flex-col items-center">
          {/* Logo Section */}
          <img
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/CIPAheaderlogo.png" 
            alt="Logo"
            className="w-auto h-20 mb-4" // Adjust width and height as needed
          />
          
          {/* Text Section */}
          <div className="text-center mb-6">
            <p className="text-black">{text}</p>
          </div>
          
          {/* Close Button */}
          <button
            onClick={!previewMode ? onClose : undefined}
            className={`bg-custom-regularOrange text-white font-bold py-2 px-6 rounded-md hover:bg-custom-darkOrange transition-colors duration-300 ${
              previewMode ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default Popup;
